// extracted by mini-css-extract-plugin
module.exports = {"Answer":"T7ExUyCfO-AC-b6i2snb4A==","label":"MRtORCSLiHPRkxSqDOUmxQ==","text":"fNIjfvyGRwdgFAdA4jtITA==","bar":"NltltCiYMM10tApW6VJOVg==","fill":"BzmPapZdh2JYaOdpATG+yQ=="};